import React, { useState } from "react";
import "./ExamCalendar.css";

const ExamCalendar = () => {
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div>
        <section className="section-council">
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">KEY TIMELINES</h2>
      <div className="sectionbottom-line"></div>
      </section>
  <div className="main-container">
    <section className="university-section" style={{width: "100%", backgroundColor: "transparent", padding: "0"}}> 
    <div className="exam-calendar">
      <h4 >Exam Calendar</h4>
      <p className="exams-description">
        ASG currently administers qualifying actuarial examinations for Levels 1 and 2 Subjects ONLY under the
        ASSA-ASG Joint Examination Programme. This means that candidates can only sit for Subjects{" "}
        <strong>L1-PAS, L1-AE, L1-AFR, L2-FM</strong> and <strong>L2-RSS</strong> in any of the two (2) sitting
        windows within the year.
      </p>

      {/* Semester 1 - Level 1 */}
      <div className="exam-section">
        <div className="exam-header" onClick={() => toggleSection("level1_sem1")}>
          Semester 1 - Level 1 Subjects (April/May Sitting) <span className="e-icon">▼</span>
        </div>
        {openSections["level1_sem1"] && (
          <table>
            <thead>
              <tr>
                <th>ASG Subjects</th>
                <th>Registration Dates</th>
                <th>Exam Dates</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>L1-PAS:</b> Probability Actuarial Statistics</td>
                <td rowspan="3"> <b>Opens:</b> January 16, 2025 <br /><br /><br /><b>Closes:</b> February 07, 2025 </td>
                <td>PART A (CS1A): April 15<br />PART B (CS1B): April 16</td>
              </tr>
              <tr>
                <td><b>L1-AE:</b> Actuarial Economics</td>
        
                <td>April 07</td>
              </tr>
              <tr>
                <td><b>L1-AFR:</b> Actuarial Financial Reporting</td>
             
                <td>April 23</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      {/* Semester 1 - Level 2 */}
      <div className="exam-section">
        <div className="exam-header" onClick={() => toggleSection("level2_sem1")}>
          Semester 1 - Level 2 Subjects (April/May Sitting) <span className="e-icon">▼</span>
        </div>
        {openSections["level2_sem1"] && (
          <table>
            <thead>
              <tr>
                <th>ASG Subjects</th>
                <th>Registration Dates</th>
                <th>Exam Dates</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>L1-FM:</b> Financial Mathematics</td>
                <td rowspan="2"><b>Opens:</b> January 16, 2025 <br /><br /><b>Closes:</b> February 07, 2025</td>
                <td>May 06</td>
              </tr>
              <tr>
                <td><b>L1-RSS:</b> Risk & Survival Statistics</td>
        
                <td>PART A (CS2A): April 10<br />PART B (CS2B): April 11</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      {/* Semester 2 - Level 1 */}
      <div className="exam-section">
        <div className="exam-header" onClick={() => toggleSection("level1_sem2")}>
          Semester 2 - Level 1 Subjects (September/October Sitting) <span className="e-icon">▼</span>
        </div>
        {openSections["level1_sem2"] && (
          <table>
            <thead>
              <tr>
                <th>ASG Subjects</th>
                <th>Registration Dates</th>
                <th>Exam Dates</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>L1-PAS:</b> Probability Actuarial Statistics</td>
                <td rowspan="3"><b>Opens:</b> <br /><br /><br /><b>Closes:</b> </td>
                <td>PART A (CS1A): Apirl 15<br />PART B (CS1B): Apirl 16</td>
              </tr>
              <tr>
                <td><b>L1-AE:</b> Actuarial Economics</td>
 
                <td>September 23</td>
              </tr>
              <tr>
                <td><b>L1-AFR:</b> Actuarial Financial Reporting</td>
             
                <td>September 10</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      {/* Semester 2 - Level 2 */}
      <div className="exam-section">
        <div className="exam-header" onClick={() => toggleSection("level2_sem2")}>
          Semester 2 - Level 2 Subjects (September/October Sitting) <span className="e-icon">▼</span>
        </div>
        {openSections["level2_sem2"] && (
          <table>
            <thead>
              <tr>
                <th>ASG Subjects</th>
                <th>Registration Dates</th>
                <th>Exam Dates</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>L1-FM:</b> Financial Mathematics</td>
                <td rowspan="2"><b>Opens:</b> January 16, 2025 <br /><br /><b>Closes:</b> February 07, 2025</td>
                <td>September 26</td>
              </tr>
              <tr>
                <td><b>L1-RSS:</b> Risk & Survival Statistics</td>
            
                <td>PART A (CS2A): September 08<br />PART B (CS2B): September 09</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>

      {/* Level 3 - GIC Actuarial Programme */}
      <div className="exam-section">
        <div className="exam-header" onClick={() => toggleSection("level3")}>
          Level 3 Subjects – GIC Actuarial Programme <span className="e-icon">▼</span>
        </div>
        {openSections["level3"] && (
          <div className="level3-content">
            <p><strong>Application Opens:</strong> March 07, 2025</p>
            <p><strong>Application Closes:</strong> March 24, 2025</p>
            <p><strong>Lecture Starts:</strong> April 21, 2025</p>
          </div>
        )}
      </div>
    </div>
    </section>

    <section className="card-section">
        <div className="accreditation-card">
        <h1 className="uni-title">Exam Registration Notes </h1>
        </div>

        <div className="accreditation-card">
        <h1 className="uni-title">Exam Resistration Form</h1>
        </div>

        <div className="accreditation-card">
        <h1 className="uni-title">Exam Refund Policy</h1>
        </div>

        <div className="accreditation-card exemption-card">
        <h1 className="uni-title">Student Handbook</h1>
        </div>

        <div className="accreditation-card exemption-card">
        <h1 className="uni-title">Study Material</h1>
        </div>
    </section>
    </div>
    </div>
  );
};

export default ExamCalendar;
